<script>
  let { word, data = [], progress = 0, playing = false, speed = 1, isAccent = true } = $props()

  let offset = $state(0)

  $effect.pre(() => {
    if (!playing) {
      offset = progress
    }
  })

  $effect(() => {
    let frame
    if (playing && data && data.length > 0) {
      let lastTime = performance.now()
      const loop = (time) => {
        const dt = time - lastTime
        lastTime = time
        offset = (offset + (dt / 1000) * speed) % data.length
        frame = requestAnimationFrame(loop)
      }
      frame = requestAnimationFrame(loop)
    }
    return () => {
      if (frame) cancelAnimationFrame(frame)
    }
  })

  let items = $derived(
    data && data.length > 0
      ? data.map((d) => d._prefix || d['bto-name']?.split(' @')[0] || '')
      : [word],
  )
</script>

<div class="wheel-track" style:--offset={offset}>
  <div class="wheel-placeholder" aria-hidden="true">{word}</div>
  {#each items as item, i}
    {@const dist = i - offset}
    {#if dist > -1 && dist < 8}
      <div class="wheel-item" class:animate-entrance={i > 0} style:--i={i} style:--dist={dist}>
        <span class="wheel-word" class:accent={isAccent && Math.abs(dist) < 0.5}>{item}</span>
      </div>
    {/if}
  {/each}
</div>

<style lang="scss">
  .wheel-track {
    position: relative;
    height: var(--item-h, 3.5rem);
    /* clip upward overflow (past-items) while keeping downward cascade open */
    clip-path: inset(0 -999rem -999rem -999rem);
    //display: flex;
    //justify-content: center;
  }

  .wheel-placeholder {
    visibility: hidden;
    height: 0;
    pointer-events: none;
    font-family: $font-selane-twenty;
    font-size: clamp(1.75rem, 4.5vw, 3.5rem);
    font-weight: 400;
    white-space: nowrap;
    line-height: 1.1;
  }

  @keyframes wheelItemFadeIn {
    from {
      opacity: 0;
      transform: translateY(1.5rem);
    }
  }

  .wheel-item {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: var(--item-h, 3.5rem);
    display: flex;
    align-items: center;
    justify-content: left;
    
    font-size: clamp(1.75rem, 4.5vw, 3.5rem);
    line-height: 1.1;
    transform-origin: left center;
    will-change: transform, opacity;
    
    opacity: max(0, 1 - max(0, var(--dist, 0)) * 0.35);
    transform: 
      translateY(calc((var(--i, 0) - var(--offset, 0)) * var(--item-h, 3.5rem)))
      scale(max(0.65, 1 - max(0, var(--dist, 0)) * 0.1));

    //&.animate-entrance {
    //  animation: wheelItemFadeIn 0.8s cubic-bezier(0.16, 1, 0.3, 1) backwards;
    //  animation-delay: calc((var(--i) - 1) * 0.12s);
    //}
  }

  .wheel-word {
    font-family: $font-selane-twenty;
    font-weight: 400;
    color: var(--scrolly-bg-text-color, #fff);
    white-space: nowrap;
    transition: color 0.15s ease;

    &.accent {
      color: var(--scrolly-bg-accent-color, var(--project-highlight-color, #cfff5e));
    }
  }
</style>
